module.exports = __webpack_public_path__ + "static/voiceAndData-e53295d9c7967185f63d48b8d4f0cb6e.jpg";